module.exports = __webpack_public_path__ + "static/img/10.7c92f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/10.png
// module id = vgXg
// module chunks = 0